import React from "react";
import { Box } from "theme-ui";
import ActionRequiredBanner from "./ActionRequiredBanner";
import ProviderOverview from "./overview/ProviderOverview";
import POsAwaitingResponse from "./POsAwaitingResponse";
import UpcomingDeliveries from "./UpcomingDeliveries";

/**
 * The provider dashboard (DASHBOARD_REDESIGN_SPEC section 5).
 *
 * The overview replaces `ProviderKPICards`, whose figures were computed
 * separately from everything else. `POsAwaitingResponse` and
 * `UpcomingDeliveries` stay: they are the provider's working lists, and
 * the overview's queue is a ranked summary above them, not a
 * replacement for the detail.
 *
 * Cost appears throughout and margin appears nowhere - the provider's
 * own price is theirs to see, ours is not.
 */
const ProviderDashboard: React.FC = () => {
  return (
    <Box>
      <ActionRequiredBanner dashboardType="provider" />

      <ProviderOverview />

      <Box sx={{ marginBottom: "24px" }} id="pos-awaiting-response">
        <POsAwaitingResponse />
      </Box>

      <Box sx={{ marginBottom: "24px" }}>
        <UpcomingDeliveries />
      </Box>
    </Box>
  );
};

export default ProviderDashboard;
